import { Injector, NgModule, inject } from '@angular/core';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { CoreImports } from './imports';
import { CoreProviders } from './providers';

@NgModule({
  imports: [CoreImports],
  exports: [CoreImports],
  providers: [CoreProviders],
})
export class AppCoreModule {
  constructor() {
    ServiceLocator.injector = inject(Injector);
  }
}
